import React from 'react'

const EmailIcon = ({ width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill={fill} width={width} height={height} {...props}>
    <path d='M4.65 6L12 11.088 19.35 6H4.65zm16.792-1.434a.75.75 0 0 1 .992.992A1.5 1.5 0 0 1 22.5 6v12a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 18V6a1.5 1.5 0 0 1 .066-.442.75.75 0 0 1 .992-.992A1.5 1.5 0 0 1 3 4.5h18a1.5 1.5 0 0 1 .442.066zM21 6.681l-8.573 5.936a.75.75 0 0 1-.854 0L3 6.68V18h18V6.681z' />
  </svg>
)

export default EmailIcon
